import { ApiVersion } from "../const";
import { User } from "../models/User";

const loginUser = (userInfo: { email: string, password: string }) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userInfo)
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}login`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })

}

const signupFinalUser = (userInfo: {name: string, surname: string,companyStr: string, email: string, phone:string, password: string, language: number}) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userInfo)
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}signup`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ code: response.status, error: response.statusText }))
        })

}

const validateToken = (token: string) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}validateToken`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })

}

const getAllUsers = (token: string, rol: number) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}getAllUsers/${rol}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

const newUser = (token: string, user: User) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify(user)
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}createUser/${user.iduser}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

const updateUser = (token: string, user: User) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify(user)
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}updateUser/${user.iduser}`, requestOptions)
        .then(response => {
            if (response.ok) { return response.json() }
            throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
        })
}

const changePassword = (token: string, iduser: number, passwords: {oldPassword: string, newPassword: string}) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify(passwords)
    };
    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}changePassword/${iduser}`, requestOptions)
    .then(response => {
        if (response.ok) {return response.json()}
        throw new Error(JSON.stringify({ error: response.status, message: response.statusText }))
    })
}

const resetPassword = (email: string) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}resetPassword/${btoa(email)}`, requestOptions)
}

const validateEmail = (userContent: string) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    return fetch(
        `${process.env.REACT_APP_API_URL}${ApiVersion}validateEmail?userContent=${encodeURIComponent(userContent)}`,
        requestOptions
    );
}

const validateUserByComercial = (userContent: string) => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    return fetch(
        `${process.env.REACT_APP_API_URL}${ApiVersion}validateUserByComercial?userContent=${encodeURIComponent(userContent)}`,
        requestOptions
    );
}

const deleteUser = (token: string, iduser: number) => {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
    };

    return fetch(`${process.env.REACT_APP_API_URL}${ApiVersion}deleteUser/${iduser}`, requestOptions)
}





export { loginUser, getAllUsers, newUser, updateUser, deleteUser, validateToken, signupFinalUser, validateEmail, resetPassword, changePassword, validateUserByComercial }